import { render, staticRenderFns } from "./LeadTimeDelivery.vue?vue&type=template&id=d63c5e02&scoped=true"
import script from "./LeadTimeDelivery.vue?vue&type=script&lang=js"
export * from "./LeadTimeDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63c5e02",
  null
  
)

export default component.exports